import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Settings, settingsFeatureKey } from '../reducers/settings.reducer';

export const selectSettings = createFeatureSelector<Settings>(settingsFeatureKey);

export const selectAllSettings = createSelector(selectSettings, state => {
  return state;
});
